<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label :for="selectID" class="control-label">{{ inputLabel }}</label>
    <slot :id="selectID">
      <select v-model.number="value" :id="selectID" class="form-control" :disabled="disableSelect">
        <option
          v-for="item in options"
          :key="item[optionValue]"
          :value="item[optionValue]"
        >
          {{ item[optionLabel] }}
        </option>
      </select>
    </slot>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
import applicationInputMixin from '@/common/mixins/applicationInputMixin';
import passInputMixin from '@/common/mixins/application-form/passInputMixin';

export default {
  name: 'DefaultSelect',

  mixins: [
    applicationFormMixin,
    applicationInputMixin,
    passInputMixin
  ],

  model: {
    prop: 'modelValue'
  },

  props: {
    id: {
      type: Number
    },

    inputLabel: {
      type: String,
      required: true
    },

    inputName: {
      default: ''
    },

    modelValue: {
    },

    optionLabel: {
      default: 'name'
    },

    optionValue: {
      default: 'id'
    },

    options: {
      type: [Array, Object],
      default: () => []
    }
  },

  computed: {
    disableSelect () {
      return this.disabledInput || this.options?.length <= 1
    },

    selectID () {
      return this._uid
    },

    value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },

  created () {
    if (this.options?.length === 1) {
      this.value = this.options[0]?.[this.optionValue]
    }
  }
}
</script>
